export const manageSession = (newSessionChoice) => {
  let currentSessionChoices =
    JSON.parse(sessionStorage.getItem("session-choices")) || {};
  Object.assign(currentSessionChoices, newSessionChoice);
  sessionStorage.setItem(
    "session-choices",
    JSON.stringify(currentSessionChoices)
  );
};
